import { ProductData } from "../types/schema.types";
import type { Product } from "schema-dts";
import { generateProduct } from "../utils/schema-generators";

/**
 * Builds Schema.org Product structured data
 * @param productData - Product information for schema generation
 * @returns Schema.org Product object (without @context — injector handles that)
 */
export function buildProductSchema(productData: ProductData): Product {
  return generateProduct(productData);
}
